<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Debtors Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Debtors Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Debtors",
          active: true,
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
      },
      totalRows: 1,
      filterTitle:'Debtors Report',
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage:50,
      IsDebtorsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      filteredReport:[],
      totals:{
        totalAmount:0,
        totalPaid:0,
        totalDiscount:0,
        totalBalance:0,
      },      
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "totalAmt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "user",
          sortable: true,
          label: "SUBMITTED BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        }
      ],      
    };
  },

  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["filterStatus","Debtors","DebtorsPagination","DebtorsPaginated","DebtorsSummary"]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("auth", ["business","branch"]),

    rows() {
      return this.IsDebtorsServerPaginated
        ? this.DebtorsPagination?.total
        : this.Debtors
        ? this.Debtors.length
        : 0;
    },

   perPage: {
      get() {
        if (this.IsDebtorsServerPaginated) {
          return (
            this.DebtorsPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsDebtorsServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchDebtors(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.DebtorsPaginated && this.DebtorsPagination
          ? this.DebtorsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.DebtorsPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },
  
  methods: {
    ...mapActions({
      FetchDebtors: "saledetails/fetchDebtors",
    }),
   
    // COMMA SEPERATORS
     thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    DebtorData(){
      if(this.Debtors){
      this.filteredReport = this.Debtors; 
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.Debtors.forEach((item)=>{
        total_amount = total_amount+parseInt(item.totalAmt);
        total_paid = total_paid+parseInt(item.totalPaid);
        total_discount = total_discount+parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount-(this.totals.totalPaid+this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;  
      this.totals.totalBalance = total_amount-(total_paid+total_discount)
      }
    },

    Excel_export() {
      axios
        .post("export_debtors", this.data,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "debtors_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
    
    handlePageChange(newPage) {
      if (this.IsDebtorsServerPaginated) {
        this.data.page = newPage;
        this.FetchDebtors(this.data);
      }
    },

    fethchDebtorsData(){
      this.FetchDebtors(this.data);
    }
  },

  watch: {
    Debtors(newValue){
      if(newValue){
        this.DebtorData();
      }
    }
  }, 

  created() {
    this.FetchDebtors(this.data);  
    this.DebtorData();  
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary">{{business}} - {{branch}}</h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-1 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="fethchDebtorsData()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
             
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-2">
              <DataTable
                  :columns="fields"
                  :rows="Debtors || []"
                  :total-rows="rows"
                  :pagination="DebtorsPagination"
                  :server-pagination="IsDebtorsServerPaginated"
                  :loading="filterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(totalAmt)="{row}">
                  {{ thousandSeperator(row.totalAmt) }}
                </template>
                <template #cell(cust)="{row}">
                    {{ row.customer }}-{{ row.customerPhone }}
                </template>
                <template #cell(amt_paid)="{row}">
                    {{ thousandSeperator(row.totalPaid) }}
                </template>
                <template #cell(discount_field)="{row}">
                  {{ thousandSeperator(row.discount) }}
                </template>
                <template #cell(balance)="{row}">
                  {{ thousandSeperator(row.balance) }}
                </template>
                <template #cell(details)="{row}">
                  <p v-for="(det,d) in row.items" :key="d">{{ det.product }},</p> 
                </template>
              </DataTable>
                <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(totals.totalAmount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{thousandSeperator(totals.totalPaid)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{thousandSeperator(totals.totalDiscount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{thousandSeperator(totals.totalBalance)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!Debtors"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
